if (!customElements.get("quick-cart-drawer")) {
  class QuickCartDrawer extends HTMLElement {
    constructor() {
      super();
      if (Shopify.designMode) {
        window.addEventListener("shopify:section:load", this.init.bind(this));
        this.parentElement.addEventListener("shopify:section:select", () => this.open());
        this.parentElement.addEventListener("shopify:section:deselect", () => this.close());
      }
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.toggleState = false;

      if (!this.classList.contains("is--open")) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }

      this.querySelector(".button--close").addEventListener("click", this.close.bind(this));
      this.querySelector(".quick-cart-drawer__backdrop").addEventListener("click", this.close.bind(this));

      this.querySelector(".quick-cart-drawer__blocks").addEventListener("keydown", e => {
        if (e.key === "Escape" && this.toggleState) {
          this.close();
        }

        if (this.toggleState) {
          const focusableElements = this.querySelectorAll(
            'button, [href], input, select, label, textarea, [tabindex]:not([tabindex="-1"])'
          );
          const firstFocusableElement = focusableElements[0];
          const lastFocusableElement = focusableElements[focusableElements.length - 1];

          let isTabPressed = e.key === "Tab";

          if (!isTabPressed) return;

          if (e.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });

      this.initTriggers();
    }

    initTriggers() {
      const observer = new MutationObserver(() => {
        document.querySelectorAll(".quick-cart-drawer__trigger").forEach(element => {
          if (!element._init) {
            element.addEventListener("click", event => {
              this.fetchProductForQuickCartDrawer(event);
            });
            element._init = true;
          }
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    // --- YENİ EKLENEN FONKSİYON: Stok Kontrolü ---
    checkVariantsAvailability() {
      try {
        const variantsJsonElement = this.querySelector('[data-product-variants-json]');
        if (!variantsJsonElement) return;

        const variants = JSON.parse(variantsJsonElement.textContent);
        
        // Ürün seçeneklerini (Fieldset'leri) bul
        // Genelde inputlar fieldset içinde olur. Yapıya göre bu seçici değişebilir.
        const fieldsets = Array.from(this.querySelectorAll('.quick-cart-drawer__main fieldset, .quick-cart-drawer__main .product-form__input'));

        fieldsets.forEach((fieldset, fsIndex) => {
          const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"], select option'));
          
          inputs.forEach(input => {
            // Kontrol edilen bu seçeneğin (input) dışındaki diğer seçili seçenekleri bul
            const currentOptionValues = fieldsets.map((fs, i) => {
              if (i === fsIndex) {
                return input.value; // Şu an kontrol ettiğimiz inputun değerini al
              }
              // Diğer seçeneklerden hangisi seçiliyse onu al
              const checked = fs.querySelector('input:checked');
              return checked ? checked.value : null;
            });

            // Bu kombinasyona uyan bir varyant var mı ve stoğu var mı?
            const matchingVariant = variants.find(variant => {
              return variant.options.every((opt, index) => opt === currentOptionValues[index]);
            });

            // Label elementini bul (Input'un hemen yanındaki)
            const label = input.nextElementSibling;

            if (!matchingVariant || !matchingVariant.available) {
              // STOK YOK: Disabled yap ve sınıf ekle
              input.setAttribute('disabled', 'disabled');
              input.classList.add('disabled');
              if (label) label.classList.add('disabled', 'sold-out');
            } else {
              // STOK VAR: Temizle
              input.removeAttribute('disabled');
              input.classList.remove('disabled');
              if (label) label.classList.remove('disabled', 'sold-out');
            }
          });
        });
      } catch (e) {
        console.error("Stok kontrolü hatası:", e);
      }
    }

    async fetchProductForQuickCartDrawer(event) {
      if (event.target.closest("card-product-slider")) {
        event.target.closest("card-product-slider").slider.autoplay.stop();
        event.target.closest("card-product-slider").classList.add("product--open-on-quick-cart");
      }

      const isRecommendations = event.target.classList.contains("quick-cart-drawer__trigger--recommendations");
      const productCard = event.target.closest("product-card");
      let productOptions = null;

      if (!isRecommendations && productCard) {
        productOptions = productCard.querySelectorAll('input[type="radio"]:checked, select');
      }

      const trigger = event.target.closest("[data-product-url]");
      trigger.classList.toggle("is--loading");
      
      try {
        let fetchPrefix = '';
        if (window.Shopify.routes.root.includes(`/${window.Shopify.locale}/`)) {
          fetchPrefix = `/${window.Shopify.locale}`;
        }

        const productCardResponse = await fetch(`${fetchPrefix}${trigger.dataset.productUrl}/?view=quick-cart`);
        if (!productCardResponse) return;

        const productCardHTML = await productCardResponse.text();
        const tempDiv = document.createElement("DIV");
        tempDiv.insertAdjacentHTML("beforeend", productCardHTML);
        
        if (!tempDiv.querySelector(".quick-cart-product")) return;
        
        this.querySelector(".quick-cart-drawer__main").innerHTML = "";
        this.querySelector(".quick-cart-drawer__main").append(tempDiv.querySelector(".quick-cart-product"));

        this.sliderInstance = new Swiper(".quick-cart-drawer__media-swiper", {
          slidesPerView: 1.25,
          spaceBetween: 8,
          freeMode: { enabled: true },
          breakpoints: { 750: { slidesPerView: 2 } }
        });
        
      } catch (error) {
        console.log(error);
      } finally {
        trigger.classList.toggle("is--loading");

        if (!isRecommendations && productOptions) {
          productOptions.forEach(productOption => {
            const quickCartDrawerOption = this.querySelector(`[name="${productOption.name}"][value="${productOption.value}"]`);
            
            // Diğerlerini temizle
            this.querySelectorAll(`[name="${productOption.name}"]`).forEach(radioInput => {
              radioInput.removeAttribute("checked");
              radioInput.closest("li")?.classList.remove("checked");
            });

            if (quickCartDrawerOption) {
              quickCartDrawerOption.setAttribute("checked", "");
              quickCartDrawerOption.closest("li")?.classList.add("checked");
              
              // Label güncelle
              const legend = quickCartDrawerOption.closest('fieldset')?.querySelector('legend');
              const span = legend?.querySelector('[data-selected-variant]');
              if (span) span.innerHTML = productOption.value;
            }

            // ID inputunu güncelle
            const idInput = this.querySelector("product-card input[name='id']");
            const sourceIdInput = productCard.querySelector('input[name="id"]');
            if (idInput && sourceIdInput) {
              idInput.value = sourceIdInput.value;
            }
          });
        }

        // --- İLK AÇILIŞTA STOK KONTROLÜNÜ ÇALIŞTIR ---
        // Ürün kartı başlatıldıktan sonra çalışmalı
        if (this.querySelector("product-card")) {
           this.querySelector("product-card").init();
        }
        
        // Bizim özel stok kontrol fonksiyonumuz:
        this.checkVariantsAvailability();

        setTimeout(() => {
          this.open();
        }, 500);

        // Event Listeners (Değişiklik Algılama)
        this.querySelector(".quick-cart-drawer__main").querySelectorAll('input[type="radio"], select').forEach(input => {
            input.addEventListener("change", event => {
              
              // 1. Etiketi Güncelle
              const fieldset = event.target.closest('fieldset');
              const legend = fieldset?.querySelector('legend');
              const span = legend?.querySelector('[data-selected-variant]');
              if (span) span.innerHTML = event.target.value;

              // 2. ID ve Görsel Güncelleme
              try {
                const selectedOptions = Array.from(this.querySelectorAll('.quick-cart-drawer__main fieldset')).map(fieldset => {
                    const checkedInput = fieldset.querySelector('input:checked');
                    return checkedInput ? checkedInput.value : null;
                });

                const variantsJsonElement = this.querySelector('[data-product-variants-json]');
                if (variantsJsonElement) {
                    const variants = JSON.parse(variantsJsonElement.textContent);
                    const matchedVariant = variants.find(variant => {
                        return variant.options.every((option, index) => option === selectedOptions[index]);
                    });

                    if (matchedVariant) {
                        const idInput = this.querySelector("input[name='id']");
                        if (idInput) {
                            idInput.value = matchedVariant.id;
                            idInput.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                        if (matchedVariant.featured_media) {
                             this.setActiveMedia(matchedVariant.featured_media.id);
                        }
                    }
                }
                
                // --- HER DEĞİŞİKLİKTE STOK DURUMUNU TEKRAR KONTROL ET ---
                this.checkVariantsAvailability();

              } catch (err) {
                  console.error("Varyasyon güncelleme hatası:", err);
              }
            });
          });
      }
    }

    setActiveMedia(id) {
      const mediaFound = Array.from(this.querySelectorAll("[data-media-id]")).find(media => Number(media.dataset.mediaId) === id);
      if (mediaFound) {
        this.sliderInstance.slideTo(Number(mediaFound.dataset.index));
      }
    }

    toggle() {
      if (!this.toggleState) {
        this.open();
      } else {
        this.close();
      }
    }

    open() {
      this.toggleState = true;
      document.querySelector("body").classList.add("overflow-hidden");
      const quickCartDrawer = document.querySelector(".quick-cart-drawer__blocks");
      const closeButton = quickCartDrawer.querySelector(".button--close");
      quickCartDrawer.setAttribute("tabindex", "0");
      closeButton.setAttribute("tabindex", "0");
      this.classList.add("is--open");
      this.opened();

      const firstFocusableElement = this.querySelector(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }

    close() {
      this.toggleState = false;
      const shopTheLookDrawer = document.querySelector("shop-the-look-drawer");

      if ((shopTheLookDrawer && !shopTheLookDrawer.classList.contains("is--open")) || !shopTheLookDrawer) {
        document.querySelector("body").classList.remove("overflow-hidden");
      }
      
      this.classList.remove("is--open");
      this.closed();
      this.toggleAriaExpanded();

      if (document.querySelector("card-product-slider.product--open-on-quick-cart")) {
        document.querySelector("card-product-slider.product--open-on-quick-cart").slider.autoplay.start();
        document.querySelector("card-product-slider.product--open-on-quick-cart").classList.remove("product--open-on-quick-cart");
      }
    }

    toggleAriaExpanded(event) {
      if (event) {
        if (event.target.closest("button"))
          event.target.closest("button").setAttribute("aria-expanded", true);
        this.querySelector(".button--close").setAttribute("aria-expanded", true);
      } else {
        document.querySelectorAll('[aria-controls="quick-cart-drawer"]').forEach(button => {
          button.setAttribute("aria-expanded", false);
        });
      }
    }

    opened() {
      const openedEvent = new Event("opened", { bubbles: true });
      this.dispatchEvent(openedEvent);
    }

    closed() {
      const closedEvent = new Event("closed", { bubbles: true });
      this.dispatchEvent(closedEvent);
    }
  }

  customElements.define("quick-cart-drawer", QuickCartDrawer);
}